module.exports = __webpack_public_path__ + "static/img/TV.42f8bc24.svg";